import logoIcon from '@/assets/icons/logo.svg';
import logoBrand from '@/assets/icons/brand.svg';
import logoA2a from '@/assets/logo_a2a_header.svg';
import styles from './Header.module.css';

export const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <a href="/" className={styles.logoSkipasser}>
          <img src={logoIcon} alt="" className={styles.logoIcon} />
          <img src={logoBrand} alt="SkiPasser" className={styles.logoBrand} />
        </a>
        <span className={styles.separator}>x</span>
        <a
          href="https://www.alps2alps.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={logoA2a} alt="Alps2Alps" className={styles.logoA2a} />
        </a>
      </div>
    </header>
  );
};
